import { render, staticRenderFns } from "./seurantajakso-erikoistuja.vue?vue&type=template&id=a521c8da&scoped=true&"
import script from "./seurantajakso-erikoistuja.vue?vue&type=script&lang=ts&"
export * from "./seurantajakso-erikoistuja.vue?vue&type=script&lang=ts&"
import style0 from "./seurantajakso-erikoistuja.vue?vue&type=style&index=0&id=a521c8da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a521c8da",
  null
  
)

export default component.exports